/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiConversionType;
(function (ApiConversionType) {
    ApiConversionType["UNSPECIFIED"] = "CONVERSION_TYPE_UNSPECIFIED";
    ApiConversionType["MACRO"] = "CONVERSION_TYPE_MACRO";
    ApiConversionType["MICRO"] = "CONVERSION_TYPE_MICRO";
})(ApiConversionType || (ApiConversionType = {}));
export function ApiConversionTypeFromJSON(json) {
    return ApiConversionTypeFromJSONTyped(json, false);
}
export function ApiConversionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiConversionTypeToJSON(value) {
    return value;
}
